import { CARD_TYPE_MAP } from './cardTypes';

const BASE_URL = '/wedding-planning';

export const CARD_PLP_LINKS = {
  [CARD_TYPE_MAP.std]: {
    text: 'Save The Dates',
    path: `${BASE_URL}/save-the-date/shop`,
  },
  [CARD_TYPE_MAP.ctd]: {
    text: 'Change The Dates',
    path: `${BASE_URL}/change-the-date/shop`,
  },
  [CARD_TYPE_MAP.invitation]: {
    text: 'Invitations',
    path: `${BASE_URL}/invitations/shop`,
  },
  [CARD_TYPE_MAP.thankyou]: {
    text: 'Thank You Cards',
    path: `${BASE_URL}/thank-you-cards/shop`,
  },
  [CARD_TYPE_MAP.menu]: {
    text: 'Menus',
    path: `${BASE_URL}/menus/shop`,
  },
  [CARD_TYPE_MAP.program]: {
    text: 'Programs',
    path: `${BASE_URL}/programs/shop`,
  },
  [CARD_TYPE_MAP.place]: {
    text: 'Place Cards',
    path: `${BASE_URL}/place-cards/shop`,
  },
  [CARD_TYPE_MAP.enclosure]: {
    text: 'Enclosures Cards',
    path: `${BASE_URL}/enclosures/shop`,
  },
  DETAILS: {
    text: 'Enclosures Cards',
    path: `${BASE_URL}/enclosures/shop`,
  },
  [CARD_TYPE_MAP.holiday]: {
    text: 'Holiday Cards',
    path: `${BASE_URL}/holiday-cards/shop`,
  },
  [CARD_TYPE_MAP.weddingShower]: {
    text: 'Wedding Shower Invitation Cards',
    path: `${BASE_URL}/bridal-shower/shop`,
  },
  [CARD_TYPE_MAP.tableNumber]: {
    text: 'Wedding Table Number Cards',
    path: `${BASE_URL}/table-numbers/shop`,
  },
  // Note: the PAPER_ADD_ONS card type exists exclusively on the FE. Since the paper add-ons PLP hosts 3 separate card types,
  // this card type was created to act as a parent or umbrella card type in order to facilitate navigation
  [CARD_TYPE_MAP.paperAddOns]: {
    text: 'Paper Add-ons',
    path: `${BASE_URL}/paper-add-ons/shop`,
  },
};

export type CardTypeWithPlpLink = keyof typeof CARD_PLP_LINKS;
export const isCardTypeWithPlpLink = (type?: string): type is CardTypeWithPlpLink => {
  if (!type) return false;
  return Object.keys(CARD_PLP_LINKS).includes(type);
};
